import { useStartCapture } from './startCapture/useStartCapture';
import { useFinishCapture } from './finishCapture/useFinishCapture';
import { XPRESSID_INFO_EVENTS_QR_CODES } from 'components/shared/XpressId/constants';
import { revokeAccessToken } from 'components/shared/XpressId/services';
import { getStatusCodeFromErrorCode } from 'utilities/video/status/getStatusCodeFromErrorCode';
import { getStatusCodeFromErrorEventCode } from 'utilities/video/status/getStatusCodeFromErrorEventCode';
import { getStatusCodeFromInfoEventCode } from 'utilities/video/status/getStatusCodeFromInfoEventCode';
import { LEAVE } from 'constants/video/status';
import { useCallback } from 'react';

export const useVideoSelfieCapture = ({ acceptedText, faceMatch, onIdentificationSuccess, onIdentificationError }) => {
    const handleServerError = ({ errorCode }) => {
        const statusCode = getStatusCodeFromErrorCode(errorCode);
        onIdentificationError({ statusCode, code: errorCode });
    };

    const handleClientError = props => {
        void revokeAccessToken();
        onIdentificationError(props);
    };

    const { accessToken, documentType } = useStartCapture({ acceptedText, faceMatch }, handleServerError);

    const handleProcessCompleted = useFinishCapture({
        onComplete: onIdentificationSuccess,
        onError: handleServerError,
    });

    const handleProcessCancelled = () => {
        handleClientError({ statusCode: LEAVE });
    };

    const handleProcessError = useCallback(
        ({ code }) => {
            const statusCode = getStatusCodeFromErrorEventCode(code);
            handleClientError({ statusCode, code, documentType });
        },
        [documentType]
    );

    const handleProcessEvents = ({ infoEvent }) => {
        const { code } = infoEvent;
        const statusCode = getStatusCodeFromInfoEventCode(code);
        statusCode && handleClientError({ statusCode, code });
        if (code === XPRESSID_INFO_EVENTS_QR_CODES.QRProcessCompleted) handleProcessCompleted();
    };

    return { accessToken, handleProcessCompleted, handleProcessCancelled, handleProcessError, handleProcessEvents };
};
